import classNames from "classnames";
import PropTypes from "prop-types";

export const List = ({ className, size = 16, fill = "currentColor", ...props }) => {
	const listClassName = classNames("list-icon", {
		[className]: className?.length > 0,
	});

	return (
		<svg
			className={listClassName}
			width={size}
			height={size}
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
			{...props}
		>
			<path
				d="M12.6422 11.4877C13.1156 11.4877 13.4993 11.8635 13.4993 12.3272C13.4993 12.7908 13.1156 13.1667 12.6422 13.1667H3.02316C2.54977 13.1667 2.16602 12.7908 2.16602 12.3272C2.16602 11.8635 2.54977 11.4877 3.02316 11.4877H12.6422Z"
				fill={fill}
			/>
			<path
				d="M12.6422 6.99383C13.1156 6.99383 13.4993 7.36969 13.4993 7.83333C13.4993 8.29698 13.1156 8.67284 12.6422 8.67284H3.02316C2.54977 8.67284 2.16602 8.29698 2.16602 7.83333C2.16602 7.36969 2.54977 6.99383 3.02316 6.99383H12.6422Z"
				fill={fill}
			/>
			<path
				d="M12.6422 2.5C13.1156 2.5 13.4993 2.87586 13.4993 3.33951C13.4993 3.80315 13.1156 4.17901 12.6422 4.17901H3.02316C2.54977 4.17901 2.16602 3.80315 2.16602 3.33951C2.16602 2.87586 2.54977 2.5 3.02316 2.5H12.6422Z"
				fill={fill}
			/>
			<path
				d="M12.6422 11.4877C13.1156 11.4877 13.4993 11.8635 13.4993 12.3272C13.4993 12.7908 13.1156 13.1667 12.6422 13.1667H3.02316C2.54977 13.1667 2.16602 12.7908 2.16602 12.3272C2.16602 11.8635 2.54977 11.4877 3.02316 11.4877H12.6422Z"
				stroke={fill}
			/>
			<path
				d="M12.6422 6.99383C13.1156 6.99383 13.4993 7.36969 13.4993 7.83333C13.4993 8.29698 13.1156 8.67284 12.6422 8.67284H3.02316C2.54977 8.67284 2.16602 8.29698 2.16602 7.83333C2.16602 7.36969 2.54977 6.99383 3.02316 6.99383H12.6422Z"
				stroke={fill}
			/>
			<path
				d="M12.6422 2.5C13.1156 2.5 13.4993 2.87586 13.4993 3.33951C13.4993 3.80315 13.1156 4.17901 12.6422 4.17901H3.02316C2.54977 4.17901 2.16602 3.80315 2.16602 3.33951C2.16602 2.87586 2.54977 2.5 3.02316 2.5H12.6422Z"
				stroke={fill}
			/>
		</svg>
	);
};

List.propTypes = {
	size: PropTypes.number,
	fill: PropTypes.string,
};
